<div class="flex flex-col flex-1 w-full h-full">
  <app-auto-complete
    [searchList]="searchResults"
    [searchBarControl]="searchFormControl"
    [isSearching]="isSearching"
    [placeholder]="placeholder"
    (handleSelectedResult)="onAdd($event)"
    class="flex flex-col flex-1"
  ></app-auto-complete>

  <div
    class="py-1 hover:bg-opacity-50 hover:bg-project-2100"
    *ngFor="let item of selectedList"
    (mouseenter)="hoveredItem = item"
    (mouseleave)="hoveredItem = null"
  >
    <div
      *ngIf="!isSurtitles"
      class="flex flex-row items-center justify-between"
    >
      <button
        *ngIf="
          (isAddButtonShown || item.canAddToContentBody) && !addToBodyFormats
        "
        class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
        data-testid="addBtn"
        title="Add to body"
        (click)="onAddToBody(item)"
      >
        <i class="icon icon-plus-circle"></i>
      </button>
      <button
        *ngIf="
          (isAddButtonShown || item.canAddToContentBody) && addToBodyFormats
        "
        type="button"
        class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
        data-testid="addFormatBtn"
        title="Add to body"
        [matMenuTriggerFor]="formatMenu"
      >
        <i class="icon icon-plus-circle"></i>
      </button>
      <mat-menu
        #formatMenu="matMenu"
        class="bg-white border rounded shadow-lg border-project-600"
        [aria-label]="'How to add ' + item.displayName + ' to the body?'"
      >
        <button
          mat-menu-item
          type="button"
          class="h-8 px-3 leading-8 min-h-0 text-xxs text-project-2400 hover:cursor-pointer hover:bg-project-2500"
          *ngFor="let option of addToBodyFormats"
          [attr.data-testid]="'addFormatOption-' + option.label"
          (click)="onAddToBodyFormatted(item, option.format)"
        >
          {{ option.label }}
        </button>
      </mat-menu>
      <p class="w-10/12 px-2 text-xs" data-testid="selected-item-display-name">
        {{ item.displayName }}
        <app-ai-icon
          *ngIf="item.isSmartLinked"
          class="text-project-2100"
          label="Added by smart linking"
          data-testid="smartLinkedMarker"
        ></app-ai-icon>
        <app-ai-icon
          *ngIf="item.isAutoTagged"
          class="text-project-2100"
          label="Added by Auto Tag"
          data-testid="autoTaggedMarker"
        ></app-ai-icon>
      </p>

      <button
        *ngIf="isInfoButtonShown"
        class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
        data-testid="infoBtn"
        title="info"
        (click)="onInfoClick(item)"
      >
        <i class="icon icon-info-circle"></i>
      </button>
      <button
        *ngIf="hoveredItem === item && isSurtitleButtonShown"
        data-testid="surtitleBtn"
        title="Promote Surtitle"
        (click)="promoteToSurtitle(item)"
        class="text-xxs h-4 whitespace-nowrap hover:text-project-300 pr-1"
      >
        Use as Surtitle
      </button>
      <button
        *ngIf="item.isRemoveButtonShown"
        class="text-base border-none bg-none text-project-100 hover:cursor-pointer hover:text-project-2700"
        data-testid="removeBtn"
        title="Remove"
        (click)="onRemove(item)"
      >
        <i class="icon icon-minus-circle"></i>
      </button>
    </div>
  </div>
</div>
